import { useTranslator, useAppContext } from '@front-activerse/common-components';

const HydrationDayGoalHeader = ({ value, goal, unit }) => {
  const { t } = useTranslator();

  const {
    images: { hydrationSuccessIcon },
  } = useAppContext();

  const limit = Math.round(goal - value);

  if (value >= goal) {
    return (
      <p className="small text-center">
        <img
          src={hydrationSuccessIcon}
          className="me-1"
          style={{ width: '24px', height: 'auto' }}
          alt=""
        />
        {t('hydration.dailyTarget.achieved')}
      </p>
    );
  }

  return (
    <p className="small text-center">{t('hydration.dailyTarget.leftToDrink', { limit, unit })}</p>
  );
};

export default HydrationDayGoalHeader;
